import { UserCreateInput, UserRole, UserUpdateInput } from "../../api";
import { builder } from "../builder";

const role = builder.string().oneOf(Object.values(UserRole));

builder.input<UserCreateInput>("UserCreateInput", {
  email: builder.string().email().required(),
  role: role.required(),
});

builder.input<UserUpdateInput>("UserUpdateInput", {
  active: builder.boolean(),
  role,
});
